import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { useCallback } from 'react';
export var useDatePickerCallbacks = function useDatePickerCallbacks(_ref, _ref2) {
  var setDirtyInternalValueVector = _ref.setDirtyInternalValueVector,
      setExternalValue = _ref.setExternalValue,
      timeSelectorValue = _ref.timeSelectorValue,
      setTimeSelectorValue = _ref.setTimeSelectorValue,
      dirtyInternalValueVector = _ref.dirtyInternalValueVector,
      externalizeValue = _ref.externalizeValue;

  var enableActionButtons = _ref2.enableActionButtons,
      restProps = _objectWithoutProperties(_ref2, ["enableActionButtons"]);

  var autoUpdateInternalValue = !enableActionButtons;
  var onDateSelectorChange = useCallback(function (newValueDateVectorRange) {
    setDirtyInternalValueVector(newValueDateVectorRange);

    if (autoUpdateInternalValue) {
      setExternalValue(externalizeValue(newValueDateVectorRange, timeSelectorValue));
    }
  }, [setExternalValue, setDirtyInternalValueVector, timeSelectorValue, autoUpdateInternalValue]);
  var onTimeSelectorValueChange = useCallback(function (newTimeSelectorValue) {
    setTimeSelectorValue(newTimeSelectorValue);

    if (autoUpdateInternalValue) {
      setExternalValue(externalizeValue(dirtyInternalValueVector, newTimeSelectorValue));
    }
  }, [dirtyInternalValueVector, autoUpdateInternalValue, setTimeSelectorValue, setExternalValue]);
  var applyValue = useCallback(function () {
    setExternalValue(externalizeValue(dirtyInternalValueVector, timeSelectorValue));
  }, [setExternalValue, dirtyInternalValueVector, timeSelectorValue]);
  return {
    restProps: restProps,
    onDateSelectorChange: onDateSelectorChange,
    onTimeSelectorValueChange: onTimeSelectorValueChange,
    applyValue: applyValue,
    enableActionButtons: enableActionButtons
  };
};